var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v(_vm._s(_vm.$t("Sign in with")))]),_c('div',{staticClass:"buttons"},_vm._l((_vm.oauthProviders),function(provider){return _c('auth-provider',{key:provider.id,attrs:{"oauthProvider":provider}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }